import { render, staticRenderFns } from "./compPool.vue?vue&type=template&id=ab2d1088&scoped=true"
import script from "./compPool.vue?vue&type=script&lang=js"
export * from "./compPool.vue?vue&type=script&lang=js"
import style0 from "./compPool.vue?vue&type=style&index=0&id=ab2d1088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2d1088",
  null
  
)

export default component.exports